import { useContext } from "react";

import { GlobalConfigurationContext } from "../contexts/globalConfiguration";

export const useGlobalConfiguration = () => {
  const context = useContext(GlobalConfigurationContext);
  if (context === undefined) {
    throw new Error("useGlobalConfiguration must be used within a GlobalConfigurationProvider");
  }
  return context;
};
